/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_A4Inputs */

const en_pc_online_faq_a4 = /** @type {(inputs: Pc_Online_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online needs WebGL2. Update your browser, make sure hardware acceleration is turned on in its settings, and reload. If it still fails, download the desktop app, which does not depend on the browser.`)
};

const zh_pc_online_faq_a4 = /** @type {(inputs: Pc_Online_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版需要 WebGL2。请更新浏览器，确认设置中已开启硬件加速，然后刷新页面。如果仍然不行，请下载不依赖浏览器的桌面版。`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online needs WebGL2. Update your browser, make sure hardware acceleration is turned on in its settings, and reload. If it still fails, download the ..." |
*
* @param {Pc_Online_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_a4 = /** @type {((inputs?: Pc_Online_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_a4(inputs)
	return zh_pc_online_faq_a4(inputs)
});
export { pc_online_faq_a4 as "pc.online.faq.a4" }